import { FC, useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "../styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { fleetUpdateDateSettings, fleetUpdateSettings } from "actions/daAndFleetActions";
import { useDispatch } from "react-redux";
import { FilterSwitch } from "componentsNew/elements/TabSwitch";
import { DateFilter } from "componentsNew/elements/DateFilter";
import { handleGetFleetStatusStats } from "../requests";
import Loader from "router/components/Loader";
import GraphStatsBox from "../GraphStatsBox";

const FleetGraphSection: FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    fleetData: { fleetList, fleetListFilters },
  } = useTypeSelectors((state) => state.daAndFleets);
  const [loading, setLoading] = useState(false);
  const [requestData, setRequestData] = useState<any>(null);

  const stations = fleetListFilters?.stations?.join("_");

  useEffect(() => {
    if (stations) {
      const params = {
        ...(fleetListFilters?.selectType === "date" && {
          day: fleetListFilters?.dateFilters?.date,
        }),
        ...(fleetListFilters?.selectType === "month" && {
          month: +Number(fleetListFilters?.dateFilters?.month.split("-")[1]),
          year: +Number(fleetListFilters?.dateFilters?.month.split("-")[0]),
        }),
        ...(fleetListFilters?.selectType === "week" && {
          week: +Number(fleetListFilters?.dateFilters?.week.split("-W")[1]) - 1,
          year: +Number(fleetListFilters?.dateFilters?.week.split("-W")[0]),
        }),
        ...(fleetListFilters?.selectType === "year" && {
          year: +Number(fleetListFilters?.dateFilters?.year),
        }),
        stations,
      };
      handleGetFleetStatusStats(params, setLoading, setRequestData);
    }
  }, [
    fleetListFilters?.selectType,
    fleetListFilters?.dateFilters?.date,
    fleetListFilters?.dateFilters?.week,
    fleetListFilters?.dateFilters?.month,
    fleetListFilters?.dateFilters?.year,
    fleetList,
    stations,
  ]);

  const handleChangeSelectType = (string: string) => {
    dispatch(fleetUpdateSettings({ selectType: string }));
  };

  const handleChangeDate = (date: string) => dispatch(fleetUpdateDateSettings({ date }));
  const handleChangeWeek = (week: string) => dispatch(fleetUpdateDateSettings({ week }));
  const handleChangeMonth = (month: string) => dispatch(fleetUpdateDateSettings({ month }));
  const handleChangeYear = (year: string) => dispatch(fleetUpdateDateSettings({ year }));

  return (
    <Box className={classes.graphSection}>
      <Loader isLoading={loading} />
      <Box className={classes.graphSectionContent}>
        <Typography className={classes.graphSectionTitle}>Fleet Status</Typography>
        <Box className={classes.filterInputs}>
          <DateFilter
            type={fleetListFilters?.selectType}
            dateValue={fleetListFilters?.dateFilters?.date}
            weekValue={fleetListFilters?.dateFilters?.week}
            monthValue={fleetListFilters?.dateFilters?.month}
            yearValue={fleetListFilters?.dateFilters?.year}
            dateChange={handleChangeDate}
            weekChange={handleChangeWeek}
            monthChange={handleChangeMonth}
            yearChange={handleChangeYear}
            isSmallSize
          />
          <FilterSwitch
            type={fleetListFilters?.selectType}
            enabledFilters={["month", "date", "week", "year"]}
            action={handleChangeSelectType}
            isSmallSize
          />
        </Box>
      </Box>
      <Box className={classes.graphStats}>
        <GraphStatsBox
          title={"Active"}
          count={requestData?.active_count}
          dataList={requestData?.data_list?.map((item: any) => item?.max_active_count) || []}
        />
        <GraphStatsBox
          title={"Inactive"}
          count={requestData?.inactive_count}
          dataList={requestData?.data_list?.map((item: any) => item?.max_inactive_count) || []}
        />
        <GraphStatsBox
          title={"Offboarded"}
          count={requestData?.off_boarded_count}
          dataList={requestData?.data_list?.map((item: any) => item?.max_offboarded_count) || []}
        />
      </Box>
    </Box>
  );
};

export default FleetGraphSection;
